var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import first from 'lodash/first';
import { EmptyRow, LoadingRow, MessengerRow } from './components';
export function ListingBody(_a) {
    var { asyncStatus, items, onRefreshItems } = _a, rest = __rest(_a, ["asyncStatus", "items", "onRefreshItems"]);
    if (asyncStatus !== 'succeeded') {
        return (_jsx(LoadingRow, { asyncStatus: asyncStatus, onRefreshItems: onRefreshItems }));
    }
    if (items.length === 0) {
        return _jsx(EmptyRow, {});
    }
    const rows = items
        .map((x) => {
        var _a;
        return ({
            messengerId: x.id,
            messengerName: x.name,
            flowId: ((_a = first(x.flows)) === null || _a === void 0 ? void 0 : _a.id) || '',
        });
    })
        .filter((x) => x.flowId !== '')
        .map((x) => (_jsx(MessengerRow, { messengerName: x.messengerName, onRename: () => rest.onRename(x.messengerId), onDelete: () => rest.onDelete(x.messengerId), onDuplicateMessenger: () => rest.onDuplicateMessenger(x.messengerId), onEditSettings: () => rest.onEditSettings(x.messengerId), onEditFlow: () => rest.onEditFlow(x.flowId), onAudit: () => rest.onAudit(x.flowId) }, x.messengerId)));
    return _jsx(_Fragment, { children: rows });
}
